import { render, staticRenderFns } from "./FeedbackShow.vue?vue&type=template&id=faa59134"
import script from "./FeedbackShow.vue?vue&type=script&lang=js"
export * from "./FeedbackShow.vue?vue&type=script&lang=js"
import style0 from "./FeedbackShow.vue?vue&type=style&index=0&id=faa59134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports